import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    feedback_text: '',
    client_assessment: null,
    communication_assessment: null,
    is_order_successful: '',
    photos_completed_order: [],
}

const feedbackCleanerSlice = createSlice({
    name: 'feedbackCleanerSlice',
    initialState,
    reducers: {
        setFeedbackText: (state, action) => {
            state.feedback_text = action.payload;
        },
        setClientAssessment: (state, action) => {
            state.client_assessment = action.payload;
        },
        setCommunicationAssessment: (state, action) => {
            state.communication_assessment = action.payload;
        },
        setIsOrderSuccessful: (state, action) => {
            state.is_order_successful = action.payload;
        },
        setPhotosCompletedOrder: (state, action) => {
            state.photos_completed_order = action.payload;
        },
        clearAllData: (state, action) => {
            state.feedback_text = '';
            state.client_assessment = null;
            state.communication_assessment = null;
            state.is_order_successful = '';
            state.photos_completed_order = [];
        }
    }
});

const {actions, reducer: feedbackCleanerReducer} = feedbackCleanerSlice;

const feedbackCleanerActions = {
    ...actions,
}

export {
    feedbackCleanerReducer,
    feedbackCleanerActions,
}